import { Routes, Route, Navigate } from 'react-router-dom';
import Catalogue, { HubLogin } from './components/catalogue/Catalogue';
import Navbar from './components/Navbar';
import Chat from './components/Chat';
import Hero from './components/Hero';
import ServicesNew from './components/ServicesNew';
import ImplementationProcess from './components/ImplementationProcess';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Faq from './components/Faq';
import ToolsStrip from './components/ToolsStrip';
import Blog from './components/Blog';
import ThaiResources from './components/resources/ThaiResources';
import Resources from './components/resources/Resources';
import ResourceDetail from './components/resources/ResourceDetail';
import Article from './components/Article';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CaseStudyCarousel from './components/CaseStudyCarousel';
import { Link, useLocation } from 'react-router-dom';
import { isThaiPath } from './content/locales';
import Seo from './components/Seo';
import CompanyPage from './components/CompanyPage';
import WorkflowPage, { WorkflowIndex } from './components/WorkflowPage';
import ServicePage from './components/ServicePage';
import LocationPage from './components/LocationPage';
import PageAnalytics from './components/PageAnalytics';
import ThaiHome from './components/ThaiHome';
import ThaiServicePage from './components/ThaiServicePage';
import { ThaiArticle, ThaiBlog } from './components/ThaiBlog';
import './styles/studio-layout.css';
export default function App() {
 const pathname = useLocation().pathname;
 const thai = isThaiPath(pathname);
 if (/^\/(?:th\/)?hub(?:\/|$)/.test(pathname)) return <><Seo /><ScrollToTop /><a href="#hub-main" className="skip-link">{thai ? 'ข้ามไปยังเนื้อหา' : 'Skip to content'}</a>{/\/hub\/login\/?$/.test(pathname) && <Navbar />}<main id="hub-main"><Routes><Route path="/th/hub/login/" element={<HubLogin />} /><Route path="/th/hub/" element={<Catalogue hub />} /><Route path="/hub/login/" element={<HubLogin />} /><Route path="/hub/" element={<Catalogue hub />} /><Route path="*" element={<Navigate to={thai ? "/th/hub/login/" : "/hub/login/"} replace />} /></Routes></main></>;
 if (pathname.replace(/\/$/, '') === '/chat') return <><Seo /><Chat /></>;
 return <div className="min-h-screen bg-[#fffcf7] text-[#1c1917]"><Seo /><PageAnalytics /><ScrollToTop /><a href="#main" className="skip-link">{thai ? 'ข้ามไปยังเนื้อหา' : 'Skip to content'}</a><Navbar /><main id="main"><Routes>
  <Route path="/apps/" element={<Catalogue />} /><Route path="/th/apps/" element={<Catalogue />} />
  <Route path="/" element={<><Hero /><ServicesNew /><ToolsStrip /><CaseStudyCarousel /><ImplementationProcess /><Pricing /><Faq /><Contact /></>} />
  <Route path="/ai-automation-singapore" element={<LocationPage country="Singapore" />} />
  <Route path="/ai-automation-thailand" element={<LocationPage country="Thailand" />} />
  <Route path="/singapore" element={<Navigate to="/ai-automation-singapore/" replace />} />
  <Route path="/thailand" element={<Navigate to="/ai-automation-thailand/" replace />} />
  <Route path="/th/resources" element={<ThaiResources />} />
  <Route path="/resources" element={<Resources />} />
  <Route path="/resources/:slug" element={<ResourceDetail />} />
  <Route path="/about" element={<CompanyPage page="about" />} />
  <Route path="/privacy" element={<CompanyPage page="privacy" />} />
  <Route path="/workflows" element={<WorkflowIndex />} />
  <Route path="/workflows/:slug" element={<WorkflowPage />} />
  <Route path="/blog" element={<Blog />} /><Route path="/blog/:slug" element={<Article />} />
  <Route path="/services/:slug" element={<ServicePage />} />
  <Route path="/th" element={<Navigate to="/th/" replace />} />
  <Route path="/th/ai-automation-thailand" element={<LocationPage country="Thailand" locale="th" />} />
  <Route path="/th/" element={<ThaiHome />} />
  <Route path="/th/services/:slug" element={<ThaiServicePage />} />
  <Route path="/th/blog/" element={<ThaiBlog />} />
  <Route path="/th/blog/:slug" element={<ThaiArticle />} />
  <Route path="/chat" element={<Chat />} />
  <Route path="*" element={<div className="max-w-3xl mx-auto px-6 py-32"><h1 className="text-4xl font-bold mb-4">Page not found</h1><p className="mb-5">Check the address or browse our guides.</p><Link className="text-[#873711] underline" to="/blog/">Explore our guides →</Link></div>} />
 </Routes></main><Footer /></div>;
}
